<script>
import router from '../../../../index';
import { useAlert } from 'dashboard/composables';
import { mapGetters } from 'vuex';
import getUuid from 'widget/helpers/uuid';

export default {
  data() {
    return {
      instanceName: '',
      isCreating: false,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    isButtonDisabled() {
      return !this.instanceName || this.isCreating;
    },
  },
  methods: {
    async createChannel() {
      this.isCreating = true;
      try {
        const tempPhoneNumber = `uaz_${new Date().getTime()}`;
        const uuid = getUuid();
        const uniqueInstanceName = `cw_${this.accountId}_${uuid}`;

        const whatsappChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: this.instanceName,
            channel: {
              type: 'whatsapp',
              provider: 'uazapi',
              phone_number: tempPhoneNumber,
              provider_config: {
                instance_name: uniqueInstanceName,
                display_name: this.instanceName,
              },
            },
          }
        );
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            accountId: this.accountId,
            page: 'new',
            inbox_id: whatsappChannel.id,
          },
        });
      } catch (error) {
        useAlert(this.$t('INBOX_MGMT.ADD.WHATSAPP.API.ERROR_MESSAGE'));
      } finally {
        this.isCreating = false;
      }
    },
  },
};
</script>

<template>
  <div class="wizard-body-content">
    <div class="w-full">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label>
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.UAZAPI.INSTANCE_NAME.LABEL') }}
          <input
            v-model="instanceName"
            type="text"
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.WHATSAPP.UAZAPI.INSTANCE_NAME.PLACEHOLDER'
              )
            "
          />
        </label>
      </div>
    </div>
    <div class="w-full">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <button
          class="button success expanded"
          :disabled="isButtonDisabled"
          @click="createChannel"
        >
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.SUBMIT_BUTTON') }}
        </button>
      </div>
    </div>
  </div>
</template>
